var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import moment from 'moment';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import * as ReviewFactory from '../../../classes/definitions/product/review';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import reviewSchema from "../../../schemas/reviewSchema";
import Input from '../../UI/Input/Input';
var ReviewForm = /** @class */ (function (_super) {
    __extends(ReviewForm, _super);
    function ReviewForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.productId = '';
        _this.editId = '';
        _this.messages = null;
        _this.parentProduct = null;
        _this.state = {
            formConfig: _.cloneDeep(reviewSchema),
            formIsValid: false,
        };
        _this.getReview = function (reviewId) {
            _this.api.getReview(reviewId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на отзив';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var review = ReviewFactory.createReview(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'name.value', review.Name);
            _.set(updatedFormConfig, 'name.touched', true);
            _.set(updatedFormConfig, 'name.valid', true);
            _.set(updatedFormConfig, 'body.value', review.Body);
            _.set(updatedFormConfig, 'body.touched', true);
            _.set(updatedFormConfig, 'body.valid', true);
            _.set(updatedFormConfig, 'rating.value', review.Rating.toString());
            _.set(updatedFormConfig, 'rating.touched', true);
            _.set(updatedFormConfig, 'rating.valid', true);
            _.set(updatedFormConfig, 'approved.value', review.Approved);
            _.set(updatedFormConfig, 'approved.touched', true);
            _.set(updatedFormConfig, 'approved.valid', true);
            _.set(updatedFormConfig, 'created_at.value', moment(review.CreatedAt).format(NotosService.dateMomentFormat));
            _.set(updatedFormConfig, 'created_at.touched', true);
            _.set(updatedFormConfig, 'created_at.valid', true);
            _.set(updatedFormConfig, 'user_email.value', review.UserEmail);
            _.set(updatedFormConfig, 'user_email.touched', true);
            _.set(updatedFormConfig, 'user_email.valid', true);
            _.set(updatedFormConfig, 'product_name.value', review.ProductName);
            _.set(updatedFormConfig, 'product_name.touched', true);
            _.set(updatedFormConfig, 'product_name.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig)
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elementType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elementType === 'checkbox') {
                updatedFormElement.value = event.checked;
            }
            else if (elementType === 'autocomplete') {
                updatedFormElement.value = event.value;
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig)
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedReview = ReviewFactory.createReview({
                name: _.get(formData, 'name.value', ''),
                body: _.get(formData, 'body.value', ''),
                rating: _.get(formData, 'rating.value', ''),
                approved: _.get(formData, 'approved.value', false),
            });
            _this.api.updateReview({ 'review': submittedReview }, _this.editId)
                .then(function (response) {
                _this.toReviewsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при редактиране на отзив';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toReviewsPage = function () {
            if (_this.productId !== '-1') {
                _this.props.history.push(AppRoutes.product.path + '/' + _this.productId + AppRoutes.reviews.path);
            }
            else {
                _this.props.history.push(AppRoutes.reviews.path);
            }
        };
        return _this;
    }
    ReviewForm.prototype.componentDidMount = function () {
        this.productId = _.get(this.props, 'match.params.id', '-1');
        this.editId = _.get(this.props, 'match.params.reviewId', '-1');
        if (this.editId !== '-1') {
            this.getReview(this.editId);
        }
    };
    ReviewForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType); } }));
        }));
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toReviewsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            actionBtns));
    };
    return ReviewForm;
}(React.Component));
// @ts-ignore
export default withRouter(ReviewForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Reviews/ReviewForm/ReviewForm.tsx
// module id = 435
// module chunks = 0